"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeOidcEvents = exports.addOidcEvents = exports.onAccessTokenExpired = exports.onUserUnloaded = exports.onUserLoaded = exports.onError = exports.login = exports.logout = exports.oidcReducer = void 0;
const tslib_1 = require("tslib");
const oidc_service_1 = require("./oidc-service");
// eslint-disable-next-line require-jsdoc
function oidcReducer(state, action) {
    switch (action.type) {
        case 'ON_ERROR':
            return Object.assign(Object.assign({}, state), { error: action.message, isLoading: false });
        case 'ON_LOADING':
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case 'ON_LOAD_USER':
            return Object.assign(Object.assign({}, state), { oidcUser: action.user, isLoading: false });
        case 'ON_UNLOAD_USER':
            return Object.assign(Object.assign({}, state), { oidcUser: undefined, isLoading: false });
        default:
            return state;
    }
}
exports.oidcReducer = oidcReducer;
const logout = (userManager, dispatch) => () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        yield oidc_service_1.logoutUser(userManager);
    }
    catch (error) {
        exports.onError(dispatch, error);
    }
});
exports.logout = logout;
const login = (userManager, dispatch, location, history) => () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: 'ON_LOADING' });
    yield oidc_service_1.authenticateUser(userManager, location, history)();
});
exports.login = login;
const onError = (dispatch, error) => {
    dispatch({ type: 'ON_ERROR', message: error.message });
};
exports.onError = onError;
const onUserLoaded = (dispatch, user) => {
    dispatch({ type: 'ON_LOAD_USER', user });
};
exports.onUserLoaded = onUserLoaded;
const onUserUnloaded = (dispatch) => {
    dispatch({ type: 'ON_UNLOAD_USER' });
};
exports.onUserUnloaded = onUserUnloaded;
const onAccessTokenExpired = (dispatch, userManager) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: 'ON_UNLOAD_USER' });
    yield userManager.signinSilent();
});
exports.onAccessTokenExpired = onAccessTokenExpired;
const addOidcEvents = ({ dispatch, userManager, customEvents }) => {
    userManager.events.addUserLoaded((user) => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserLoaded) === null || _a === void 0 ? void 0 : _a.call(customEvents, user);
        exports.onUserLoaded(dispatch, user);
    });
    userManager.events.addSilentRenewError((error) => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onSilentRenewError) === null || _a === void 0 ? void 0 : _a.call(customEvents, error);
        exports.onError(dispatch, error);
    });
    userManager.events.addUserUnloaded(() => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserUnloaded) === null || _a === void 0 ? void 0 : _a.call(customEvents);
        exports.onUserUnloaded(dispatch);
    });
    userManager.events.addUserSignedOut(() => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserSignedOut) === null || _a === void 0 ? void 0 : _a.call(customEvents);
        exports.onUserUnloaded(dispatch);
    });
    userManager.events.addAccessTokenExpired(() => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onAccessTokenExpired) === null || _a === void 0 ? void 0 : _a.call(customEvents);
        exports.onAccessTokenExpired(dispatch, userManager);
    });
    if (customEvents === null || customEvents === void 0 ? void 0 : customEvents.onAccessTokenExpiring) {
        userManager.events.addAccessTokenExpiring(customEvents.onAccessTokenExpiring);
    }
    if (customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserSessionChanged) {
        userManager.events.addUserSessionChanged(customEvents.onUserSessionChanged);
    }
};
exports.addOidcEvents = addOidcEvents;
const removeOidcEvents = ({ dispatch, userManager, customEvents }) => {
    userManager.events.removeUserLoaded((user) => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserLoaded) === null || _a === void 0 ? void 0 : _a.call(customEvents, user);
        exports.onUserLoaded(dispatch, user);
    });
    userManager.events.removeSilentRenewError((error) => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onSilentRenewError) === null || _a === void 0 ? void 0 : _a.call(customEvents, error);
        exports.onError(dispatch, error);
    });
    userManager.events.removeUserUnloaded(() => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserUnloaded) === null || _a === void 0 ? void 0 : _a.call(customEvents);
        exports.onUserUnloaded(dispatch);
    });
    userManager.events.removeUserSignedOut(() => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserSignedOut) === null || _a === void 0 ? void 0 : _a.call(customEvents);
        exports.onUserUnloaded(dispatch);
    });
    userManager.events.removeAccessTokenExpired(() => {
        var _a;
        (_a = customEvents === null || customEvents === void 0 ? void 0 : customEvents.onAccessTokenExpired) === null || _a === void 0 ? void 0 : _a.call(customEvents);
        exports.onAccessTokenExpired(dispatch, userManager);
    });
    if (customEvents === null || customEvents === void 0 ? void 0 : customEvents.onAccessTokenExpiring) {
        userManager.events.removeAccessTokenExpiring(customEvents.onAccessTokenExpiring);
    }
    if (customEvents === null || customEvents === void 0 ? void 0 : customEvents.onUserSessionChanged) {
        userManager.events.removeUserSessionChanged(customEvents.onUserSessionChanged);
    }
};
exports.removeOidcEvents = removeOidcEvents;
//# sourceMappingURL=oidc-events.js.map